
import { useCurrentUser } from "services/currentUserService.js";

const enum AccessRightSections {
    Case = "case",
    Accounts = "accounts",
    Reports = "reports",
}


export const enum CaseAccessRights {
    ModifyClient = "ModifyClient",
    ModifyMatter = "ModifyMatter",
    EditWorkFlow = "EditWorkFlow",
    DeleteTasks = "DeleteTasks",
}

export const enum AccountsAccessRights {
    ViewMatterLedger = "ViewMatterLedger",
}

export const enum ReportsAccessRights {
    ClientListing = "ClientListing",
    MatterBalances = "MatterBalances",
    Disbursements = "Disbursements",
    Billing = "Billing",
    SupplierBalance = "SupplierBalance",
    NominalBalance = "NominalBalance",
    BankRec = "BankRec",
}




export function useCaseAccess(right: CaseAccessRights): boolean {
    const user = useCurrentUser();
    return user?.data?.profile?.[AccessRightSections.Case]?.[right] === true;
}

export function useAccountsAccess(right: AccountsAccessRights): boolean {
    const user = useCurrentUser();
    return user?.data?.profile?.[AccessRightSections.Accounts]?.[right] === true;
}

export function useReportsAccess(right: ReportsAccessRights): boolean {
    const user = useCurrentUser();
    return user?.data?.profile?.[AccessRightSections.Reports]?.[right] === true;
}





